import { Redirect } from "react-router-dom";

const CseReload = ({ match }: { match: any }) => {
  const cseId = match.params.cseId;
  const tab = match.params.tab;
  return <Redirect to={"/cse/" + cseId + "/" + tab} />;
};
export default CseReload;
